import { z } from "zod";

export enum MeetingAppointmentErrors {
  /** email field is missing or blank */
  EmailMissing = "EmailMissing",
  /** name field is missing or blank */
  NameMissing = "NameMissing",
  /** phone field is missing or blank */
  PhoneMissing = "PhoneMissing",
  /** email field does not contain a valid email address */
  EmailInvalid = "EmailInvalid",
  /** phone field does not contain a valid phone number */
  PhoneInvalid = "PhoneInvalid",
  /** meeting type is not a supported value */
  MeetingTypeInvalid = "MeetingTypeInvalid",
  /** time slot does not exist or is not a valid time */
  TimeSlotInvalid = "TimeSlotInvalid",
  /** time slot has already been booked or disappeared due to calendar conflicts */
  TimeSlotAlreadyBooked = "TimeSlotAlreadyBooked",
  /** an answer that is required has not been provided */
  RequiredAnswerMissing = "RequiredAnswerMissing",
  /** an answer is not one of the set choices */
  AnswerInvalid = "AnswerInvalid",
}

export const meetingAppointmentErrorCode = z.enum(MeetingAppointmentErrors);

const error = z.object({
  code: meetingAppointmentErrorCode,
  subject: z.string().nullable(),
});

const outcome = z.object({
  success: z.boolean(),
  /** if success is true, contains a success message for the user */
  message: z.string().nullable(),
  errors: z.array(error),
});

export const bookingAppointmentsPostResponse = z.object({
  outcome,
});

export type BookingAppointmentsPostResponse = z.infer<
  typeof bookingAppointmentsPostResponse
>;
